import { EventEmitter } from 'events';
import 'whatwg-fetch';
import TemplateEngine from "../3rdparty/template-engine";

export default class Locator {

    constructor() {
        this.url = '//maps.googleapis.com/maps/api/js?language=nl';

        const $el = document.querySelector('[data-locator]');

        if ($el) {
            const API_KEY = $el.dataset.googleapi || null,
            LOCATIONS_ENDPOINT = $el.querySelector('form').getAttribute('action'),
            RANGE_ENDPOINT = $el.querySelector('form').dataset.range_endpoint,
            SEARCH_ENDPOINT = $el.querySelector('form').dataset.search_endpoint;

            if (API_KEY) {
                this.url += '&key=' + API_KEY;
            }
    
            // Model
            this.markerModel = new MarkerModel(LOCATIONS_ENDPOINT);
    
            // Views
            this.mapView = new MapView(this.markerModel, this.url);
            this.formView = new FormView(this.markerModel, $el, SEARCH_ENDPOINT, RANGE_ENDPOINT, this.mapView);
            
            this._init();
        }
    }

    _init() {
        this._loadGoogleAPI(this.url, this.markersurl).then((value) => {
            // Resolved
            this.mapView.init();
            this.markerModel.getData();
        }, (value) => {
            // Rejected
            console.error('Script not found:', value)
        });
    }

    /**
     * Async loading of the Google Maps API javascript file.
     * @param url
     * @returns {Promise}
     * @private
     */
    _loadGoogleAPI(url, markersurl) {
        let googleMapsPromise = new Promise(function (resolve, reject) {

            // Create a new script tag
            let script = document.createElement('script');
            // Use the url argument as source attribute
            script.src = url;

            let markerscript = document.createElement('script');
            // Use the url argument as source attribute
            markerscript.src = markersurl;

            // Call resolve when it is loaded
            script.addEventListener('load', function () {
                resolve(url, markersurl);
            }, false);

            // Reject the promise if there’s an error
            script.addEventListener('error', function () {
                reject(url, markersurl);
            }, false);

            // Add it to the body
            document.body.appendChild(script);
        });

        return googleMapsPromise;
    }
}

// ------------------------
// 					MODELS
// ------------------------
class MarkerModel extends EventEmitter {

    constructor(url) {
        super();

        this.url = url;
        this.markers = [];
    }

    /**
     * Fetch markers
     */
    getData() {
        // Make a ajax call to the server
        fetch(this.url)
            .then(function (response) {
                return response.json();
            })
            .then((json) => {
                // on response fire an event.
                this._onchange(json);
            })
            .catch(function (ex) {
                console.log('parsing failed', ex);
            });
    }

    /**
     * When model is changed notify it's observers.
     * @private
     */
    _onchange(data) {
        // Fire custom change event.
        this.emit('change', data);
    }
}

// ------------------------
// 					VIEWS
// ------------------------
class FormView extends EventEmitter {

    constructor(model, $formElement, searchEndpoint, endpoint, map) {
        super();

        var self = this;
        this.model = model;
        this.map = map;
        this.$form = $formElement;
        this.endpoint = endpoint;
        this.searchEndpoint = searchEndpoint;

        this.$inputField = this.$form.querySelector('input');
        this.$inputField.addEventListener('keyup', () => this._getLocationsByInput(this.$inputField, this.$inputField.value))
        this.$form.addEventListener('submit', e => this._handleSubmit(e));

        model.on('change', (data) => this.update(data));
    }

    disableSubmit(status) {
        if (status) {
            this.$form.querySelector('button[type="submit"]').disabled = true;
        } else {
            this.$form.querySelector('button[type="submit"]').disabled = false;
        }
    }

    update($data) {
        if ($data.length == 0) {
            this.disableSubmit(false);
        }
    }

    _getFormData(form) {
        let formElements = form.elements;
        let postData = {};
        for (let i = 0; i < formElements.length; i++) {
            // We dont want to include the submit-buttom
            if (formElements[i].type != "submit" && formElements[i].name) {
                postData[formElements[i].name] = formElements[i].value;
            }
        }
        return postData;
    }

    _getLocationsByInput(input, inputValue) {
        const dropdown = this.$form.querySelector('.locator__dropdown');

        if(inputValue.length < 2){
            dropdown.innerHTML = '';
            dropdown.classList.remove('show');
            return;
        }

        // Make a ajax call to the server
        const params = inputValue ? '?query=' + inputValue : '';

        return fetch(this.searchEndpoint + params)
            .then( response => {
                return response.json();
            })
            .then(result => {
                dropdown.innerHTML = '';
                result.forEach(row => {
                    const node = document.createElement("li");
                    const textnode = document.createTextNode(`${row.city}, ${row.province}`);

                    node.appendChild(textnode);
                    node.addEventListener('click', e => {
                        input.value = row.city;
                        dropdown.classList.remove('show');
                        Promise.resolve(this._getLocationsInRangeData(inputValue, row.key)).then(locations => {
                            this.zoomToLocationInRange(locations);
                        });
                    });
                    dropdown.appendChild(node);
                })
                dropdown.classList.add('show');
            })
            .catch(ex => {
                console.log('parsing failed', ex);
            });
    }

    _getLocationsInRangeData(query, cityKey) {
        // Make a ajax call to the server
        var params = query ? '?query=' + query : '';
        params += cityKey ? '&citykey=' + cityKey : '';

        console.log(this.endpoint + params)

        return fetch(this.endpoint + params)
            .then(function (response) {
                if (response.status != 200) {
                    return [];
                }
                return response.json();
            })
            .catch(function (ex) {
                console.log('parsing failed', ex);
            });
    }

    _handleSubmit(e) {
        e.preventDefault();
        e.stopPropagation();

        const data = this._getFormData(e.target);

        Promise.resolve(this._getLocationsInRangeData(data.query)).then(locations => {
            this.zoomToLocationInRange(locations);
        });
    }

    zoomToLocationInRange(locations) {
        self.markers = this.model.markers;
        self.matchedLocationMarkers = [];
        self.map = this.map.map;
        console.log(this.map)

        if (locations) {
            for (let marker of self.markers) {
                for (let location of locations) {
                    if (marker.community.Zipcode && marker.community.Zipcode.includes(location.Zipcode)) {
                        self.matchedLocationMarkers.push(marker);
                        break;
                    }
                }
            }

            if(self.matchedLocationMarkers[0]) {
                this.map._closeAllInfoWindows()
                self.matchedLocationMarkers[0].infoWindow.open(this.map, self.matchedLocationMarkers[0].marker);
                let latlng = new google.maps.LatLng(self.matchedLocationMarkers[0].community.Latitude, self.matchedLocationMarkers[0].community.Longitude);
                self.map.panTo(latlng);
                self.map.setZoom(11);
            } else {
                const infoAlert = document.querySelector('.locator__submit-info');
                infoAlert.classList.add('show');

                setTimeout(() => {
                    infoAlert.classList.remove('show')
                }, 3000);
            }
        }
    }
}

class MapView extends EventEmitter {

    constructor(model, url) {
        super();

        this.model = model;
        this.$map = document.getElementById('gmap');
        this.url = url;

        model.on('change', (data) => this.update(data, model));
    }

    /**
     * When Google API is fully loaded we initialize the map
     */
    init() {
        this.markers = this.model.markers;
        this.infowindowtmpl = document.getElementById('tmpl-infowindow').innerHTML;
        this.map = new google.maps.Map(this.$map, {
            zoom: 7,
            center: { lat: 52.08889, lng: 5.11556 },
            disableDefaultUI: true,
            zoomControl: true,
            mapTypeControl: false,
            scaleControl: false,
            streetViewControl: false,
            scrollwheel: false,
            rotateControl: false,
            fullscreenControl: false
        });
    }

    update($data, model) {
        // Clear markers
        // ...
        for (let item of this.markers) {
            item.marker.setMap(null);
        }

        // Place new markers
        // ...
        this._placeMarkers($data);
    }

    /**
     * Close all other info windows.
     *
     * @private
     */
    _closeAllInfoWindows() {
        for (let a = 0; a < this.markers.length; a++) {
            this.markers[a].infoWindow.close();
        }
    }

    _placeMarkers(data) {
        // Loop through markers...
        let i = 0,
            bounds = new google.maps.LatLngBounds;



        for (let item of data) {
            item._index = i;

            let image = '/static/img/locator-marker.png';
            let latlng = new google.maps.LatLng(item.Latitude, item.Longitude);
            let marker = new google.maps.Marker({
                position: latlng,
                map: this.map,
                title: item.Name,
                icon: image
            });
            let markerHMTL = TemplateEngine(this.infowindowtmpl, {
                NAME: item.Name,
                DESCRIPTION: item.Description,
                LINK: item.Link
            })
            markerHMTL = markerHMTL.replace('&lt;%this.LINK%&gt;', item.Link);
            let infoWindow = new google.maps.InfoWindow({
                content: markerHMTL,
                maxWidth: 1000
            });

            google.maps.event.addListener(marker, 'click', () => {
                // Close all other info windows.
                this._closeAllInfoWindows();
                // Open this infowindow.
                infoWindow.open(this.map, marker);
            });

            // Add marker to the map.
            marker.setMap(this.map);

            // We extend the bounds so we can view all markers on the map.
            bounds.extend(latlng);

            // Store markers and infowindows.
            this.markers.push({ marker: marker, infoWindow: infoWindow, community: item });

            // Set the map to show all markers.
            // this.map.fitBounds(bounds);

            i++;
        } // End for loop\
    }
}